import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the manageProfilePage state domain
 */

const selectManageTopUpDomain = state =>
  state.get('manageInvoices', initialState);

/**
 * Other specific selectors
 */

/**
 * Default selector used by ManageProfilePage
 */

const makeSelectManageTopUp = () =>
  createSelector(selectManageTopUpDomain, substate => substate.toJS());

export default makeSelectManageTopUp;
export { selectManageTopUpDomain };
